import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {initializedFirebaseApp} from "./Firebase";
import { getAnalytics } from "firebase/analytics";
import App from "./App";

import mixpanel from "mixpanel-browser";


// Near entry of your product, init Mixpanel
mixpanel.init("0cd8b639c500d2f90b33084bdf33efd9", {
    debug: false,
    track_pageview: true,
    persistence: "cookie",
    ignore_dnt: true,
});

getAnalytics(initializedFirebaseApp);


const root = createRoot(document.getElementById('root'));
root.render(
    <StrictMode>
        <App />
    </StrictMode>
);
